import React, { useEffect, useState, useRef } from "react";
import './CreateOTSEvent.scss';
import AddOTSForm from "../OtsForm/AddOTSForm";
import "../OtsForm/AddOTSForm.scss";
import "@aurodesignsystem/auro-button";
import OTSHistory from './OTSHistory';
import { createOTSEvent } from "../../services/otsEventService";
import CancelModal from "../Modal/CancelModal";
import FlightPath from './FlightPath';
import "@aurodesignsystem/auro-dropdown";
import EventDetails from "../EditOtsForm/EventDetails";
import { useAuthentication } from "meportal/AuthenticationProvider";
import { useDispatch } from "react-redux";
import { addEvent } from "../../store/feature/OpenEventsListSlice";
import AddOTSComment from "./AddOTSComment";
import { useToast } from "../../providers/ToastProvider";
import { NOTIFICATION_TYPES } from "../ToastNotification/toastConstants";
import { logInformation, logError } from "meportal/Logger";
import { APP_NAME_APPINSIGHTS } from "../../constants/Constants";
import { getDatetimeUtcNowString } from "../../helpers/DateTime";

export default function CreateOTSEvent(props) {
    const dispatch = useDispatch();
    const { handledata }=props;
    const { userData, getLatestAccessToken } = useAuthentication();
    const [ataCode, setAircraftATA] = React.useState("");
    const [aircraftNumber, setAircraftNumber] = React.useState("");
    const [isSubmitDisabled, setIsSubmitDisabled] = React.useState(true);
    const [otsEventData, setOtsEventData] = React.useState<OtsEvent>();
    const [status, setStatus] = React.useState("");
    const [loaded, setLoadedData] = useState(false);
    const [isHistoryEvent, setIsHistoryEvent] = useState(true);
    const [reloadEventHistoryDetails, setReloadEventHistoryDetails] = useState(false);
    const [postEventData, setPostEventData] = React.useState<SendEventData>();
    const [publicAttachmentCount, setPublicAttachmentCount] = useState(0);
    const publicAttachmentCountRef = useRef(publicAttachmentCount);
    const { addToast } = useToast();
    const messageBoxTextRef = useRef<string>();
    const moduleName = `${APP_NAME_APPINSIGHTS}-CreateOTSEvent`;

    const [onTailValidChange, setOnTailValidChange] = React.useState(false);
    const handleReload = (loader: any) => {
        setLoadedData(loader);
        setReloadEventHistoryDetails(loader);
    };
    const handleAddOTS = (otsevent: OtsEvent) => {
        console.log('ots event : ', otsevent);
        otsevent.lastUpdatedBy = userData?.profile?.name;
        setOtsEventData(otsevent);
        setIsSubmitDisabled(otsevent.isSubmitDisabled);
    };

    const handleAddSubmit = () => {
        setStatus("loading");
        const formattedOutOfServiceTime = otsEventData?.outOfServiceTime.slice(0, 16);
        //set public attachment bool to true if there are any public attachments
        otsEventData && (otsEventData.HasPublicAttachment = publicAttachmentCountRef.current > 0);
        //send the comment to the API for safety net in case the conversation is not created
        otsEventData && (otsEventData.conversationPublicComment = messageBoxTextRef.current ?? "");
        getLatestAccessToken().then((token) => {
            userData.access_token = token;
            createOTSEvent(userData, otsEventData)
                .then((statusCode) => {
                    console.log("statusCode createOTSEvent: ", statusCode);
                    if (statusCode === 200) {
                        //sending to conversation code
                        // put in state
                        dispatch(addEvent(otsEventData!));
                        console.log("");
                        const eventdata: SendEventData = {
                            IspostButtonClick: true,
                            IsRemoveButtonClick: false,
                            IsRestoreButtonClick: false,
                            EventTitle: "Event created",
                            UniqueConvoKey: `N${otsEventData?.tail}:${formattedOutOfServiceTime}`,
                            createConversation: true
                        };
                        setPostEventData(eventdata);
                        logInformation(
                            `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Success response from create ots, creating conversation. Conversation key: ${eventdata.UniqueConvoKey} User: ${userData?.profile?.email}`,
                            moduleName,
                            "handleAddSubmit"
                          );
                    } else {
                        setStatus("error");
                        setTimeout(() => {
                            setStatus("");
                        }, 5000);
                    }
                })
                .catch(() => {
                    console.log("Failed Error createOTSEvent");
                    setStatus("error");
                    setTimeout(() => {
                        setStatus("");
                    }, 5000);
                });
            });
    };
    const [showCancelModal, setShowCancelModal] = React.useState(false);

    const passdata = () => {
        handledata({
            status, isSubmitDisabled, handleClose, handleAddSubmit
        })
    }

useEffect(() => {
        passdata();
}, [status, isSubmitDisabled, otsEventData ]);
    const handleClose = () => {
        setShowCancelModal(true);
    };

    const handleKeepEditing = () => {
        setShowCancelModal(false);
    };

    const handleCancelEvent = () => {
        window.location.href = '/';
        setShowCancelModal(false);
    };

    const Overlay = () => {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(245, 246, 248, 0.5)',
                zIndex: 2,
            }}></div>
        );
    }
    
    const handleLoadedData = (data: boolean) => {
        setLoadedData(data);  
      };


    const handleMessageDataChange = (messageData: any) => {
        messageBoxTextRef.current = messageData?.messageBoxText;
    };

    const handleActiveHeader = (header: any) => {
        console.log("Active Header: ", header);
    }

    const handleTwilioMessageSent = (twilioResponse: any) => {
        if (twilioResponse){
            setStatus("success");
            logInformation(
                `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Success response from create conversation. Tail:OTS time: ${otsEventData?.tail}:${otsEventData?.outOfServiceTime} User: ${userData?.profile?.email}`,
                moduleName,
                "handleTwilioMessageSent"
              );
            setTimeout(() => {
                setStatus("");
                window.location.href = '/';
            }, 5000);
        } 
         else{
            setStatus("error");
            addToast(NOTIFICATION_TYPES.WARNING, 'Unable to save comment while creating new event.', '', false);
            logError(
                `${getDatetimeUtcNowString("YYYY-MM-DD HH:mm:ss")}Z => Create conversation failed or message addition failed. Tail:OTS time: ${otsEventData?.tail}:${otsEventData?.outOfServiceTime} User: ${userData?.profile?.email}`,
                moduleName,
                "handleTwilioMessageSent"
              );
            setTimeout(() => {
                setStatus("");
            }, 5000);
         }
    };

    useEffect(() => {
        if(aircraftNumber.length !== 5 && reloadEventHistoryDetails === true) {
            setReloadEventHistoryDetails(false);         
        }
    }, [aircraftNumber, onTailValidChange]);

    const handlePublicAttachmentCount = (count: number) => {
        setPublicAttachmentCount(count);
    }

    useEffect(() => {
        publicAttachmentCountRef.current = publicAttachmentCount;
    }, [publicAttachmentCount]);
    
    return (
        <React.Fragment>
            {status !== "" && <Overlay />}
            
            <div>
                <div className="container-create create-css">
                    <div className="event-details" >
                        <AddOTSForm onAddOTS={handleAddOTS}  cancelbox={showCancelModal} setAircraftATA={setAircraftATA} setAircraftNumber={setAircraftNumber} setOnTailValidChange={setOnTailValidChange} />
                    </div>
                    <div className="event-history">
                        <OTSHistory aircraftNumber={aircraftNumber} ataCode={ataCode} reload={handleReload} isTailValid={onTailValidChange} />
                    </div>
                    <div className="flight-info" > 
                        <span className="header-form-fields">Flt Sched.</span>
                        <FlightPath aircraftNumber={aircraftNumber} isTailValid={onTailValidChange}></FlightPath>
                    </div>
                    <div className="create-message">
                        <AddOTSComment handleMessageDataChange={handleMessageDataChange} postEventData={postEventData} handleActiveHeader={handleActiveHeader} handleTwilioMessageSent={handleTwilioMessageSent} handlePublicAttachmentCount={handlePublicAttachmentCount} userData={userData}
                        />
                    </div>
                    { reloadEventHistoryDetails && <div className="create-history-event-details">
                    <span className="header-form-fields">Recent Event History Details</span>
                        <div className="event-details-history">
                            <div className="event-details-history-info">
                                <EventDetails 
                                        open={false}
                                        loadedData={handleLoadedData}
                                        isHistoryEvent={isHistoryEvent}
                                    />
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            <CancelModal 
            message="Are you sure you want to cancel the new event?"
            title="Cancel New Event"
            buttonText="Yes"
            isOpen={showCancelModal} 
            close={handleKeepEditing} 
            confirm={handleCancelEvent} />
        </React.Fragment>

    );
}
